import { useState, useEffect, useCallback } from 'react';

const useHasClaim = () => {
  const [claims, setClaims] = useState([]);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    const userClaims = storedUser?.claims || [];

    setClaims(userClaims);
  }, []);

  const hasClaim = useCallback(
    (requiredClaims) => {
      if (!claims || !Array.isArray(claims)) return false;
      return requiredClaims?.some((claim) => claims.includes(claim));
    },
    [claims],
  );

  return { hasClaim };
};

export default useHasClaim;
